// @flow
import styled from 'styled-components';
import { white, g300, albasterGrey, errorBg, daveGrey, errorText, silverGrey, flamingo, blackGrey } from '../../colors';
import { ReactComponent as Remove } from '../../static-icons/remove.svg';
/*::
import type { Node } from 'react';

export type MultiInputThemeType = {|
  Main: * => Node,
  Value: * => Node,
  ValueText: * => Node,
  ValueIcon: * => Node,
  Input: * => Node,
|};
*/

var MultiInputTheme
/*: MultiInputThemeType */
= {
  // default theme
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "sc-1kr104e-0"
  })(["outline:none;display:flex;flex-direction:row;flex-wrap:wrap;position:relative;min-height:5.6rem;padding:2.5rem 1rem 0 1rem;width:100%;background-color:", ";color:", ";font-size:1.6rem;font-weight:300;border-bottom:1px solid ", ";&:focus-within{color:", ";border-bottom:1px solid ", ";}"], function (pr) {
    return pr.error ? errorBg() : albasterGrey();
  }, daveGrey(), function (pr) {
    return pr.error ? errorText() : silverGrey();
  }, blackGrey(), function (pr) {
    return pr.error ? errorText() : flamingo();
  }),
  Value: styled.div.withConfig({
    displayName: "theme__Value",
    componentId: "sc-1kr104e-1"
  })(["display:flex;flex-direction:row;align-items:center;height:auto;margin:0 0.8rem 1rem 0;padding:0.3rem 0.5rem 0.3rem 0.8rem;background-color:", ";border:1px solid ", ";border-color:", ";border-radius:1.7rem;&>svg{width:1.6rem;cursor:pointer;}"], function (pr) {
    return pr.isValid ? white() : errorBg();
  }, g300(), function (pr) {
    return pr.isValid ? g300() : errorText();
  }),
  ValueText: styled.div.withConfig({
    displayName: "theme__ValueText",
    componentId: "sc-1kr104e-2"
  })(["margin-right:0.8rem;word-break:break-all;"]),
  ValueIcon: styled(Remove).withConfig({
    displayName: "theme__ValueIcon",
    componentId: "sc-1kr104e-3"
  })(["flex-shrink:0;"]),
  Input: styled.input.withConfig({
    displayName: "theme__Input",
    componentId: "sc-1kr104e-4"
  })(["height:2.7rem;color:inherit;font-size:inherit;font-weight:inherit;border:none;background:none;outline:none;width:", "ch;padding:0;margin:0 0.8rem 1rem 0;"], function (pr) {
    return pr.inputLength;
  })
};
export default MultiInputTheme;